import { X } from "lucide-react";

// A download failure or a missing soil map stays on the panel until the person dismisses it.
// Closing the panel is a different control.
export function Section180Note(props: { note: string; onDismiss: () => void }) {
  const { note, onDismiss } = props;
  return (
    <div className="mx-4 mb-3 flex items-start gap-2 rounded border border-line bg-canvas/40 p-2 text-[11px] leading-snug text-fg">
      <span className="flex-1">{note}</span>
      <button
        onClick={onDismiss}
        className="text-muted hover:text-fg"
        aria-label="Dismiss"
      >
        <X size={12} />
      </button>
    </div>
  );
}
